/* import __COLOCATED_TEMPLATE__ from './sq-breadcrumb.hbs.js'; */
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';

/**
## SqBreadcrumb

Displays a dynamic breadcrumb style navigation bar.

```example
@title Example

@controller-properties
{
  breadcrumbStack: [{ label: 'Home', index: 0 }],
  actions: {
    selectBreadcrumb: function(breadcrumb) {
      this.set('breadcrumbStack', this.get('breadcrumbStack').slice(0, breadcrumb.index + 1));
    },
    goDeeper: function() {
      const newIndex = this.get('breadcrumbStack.length');
      this.set('breadcrumbStack', [...this.get('breadcrumbStack'), { label: `Page ${newIndex}`, index: newIndex }])
    }
  },
}

@hbs
{{#sq-breadcrumb breadcrumbs=breadcrumbStack as |breadcrumb isSelectable|}}
  {{~#if isSelectable~}}
    <a {{action "selectBreadcrumb" breadcrumb}}>{{breadcrumb.label}}</a>
  {{~else~}}
    <span>{{breadcrumb.label}}</span>
  {{~/if~}}
{{/sq-breadcrumb}}
<a {{action "goDeeper"}}>Go deeper</a>
```

### Parameters
 * @param {array} breadcrumbs Objects that will be yielded. All but the last one will be yielded with a second parameter, isSelectable, being `true`. For the last one, `isSelectable` is false.

Sass dependencies at: `@square/glass-ui/addon/styles/@square/selector/breadcrumbs/_breadcrumbs.scss`
*/
let SqBreadcrumb = (_dec = tagName('h3'), _dec2 = computed('breadcrumbs.[]'), _dec3 = readOnly('breadcrumbs.lastObject'), _dec(_class = (_class2 = class SqBreadcrumb extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "finalBreadcrumb", _descriptor, this);
  }
  init() {
    super.init();
    if (!this.breadcrumbs) {
      this.set('breadcrumbs', []);
    }
  }
  get selectableBreadcrumbs() {
    const breadcrumbs = this.breadcrumbs;
    return breadcrumbs.slice(0, -1);
  }
}, _applyDecoratedDescriptor(_class2.prototype, "selectableBreadcrumbs", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "selectableBreadcrumbs"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "finalBreadcrumb", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { SqBreadcrumb as default };